import { render, staticRenderFns } from "./CardCategories.vue?vue&type=template&id=412204a8&scoped=true&"
import script from "./CardCategories.vue?vue&type=script&lang=js&"
export * from "./CardCategories.vue?vue&type=script&lang=js&"
import style0 from "./CardCategories.vue?vue&type=style&index=0&id=412204a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412204a8",
  null
  
)

export default component.exports